/*
  Linha agrupada do COMBO no carrinho lateral (snippets/cart-combo-grupo.liquid).

  −, + e Remover mexem no combo INTEIRO: cada linha do combo muda na proporção de uma
  composição (ex.: 4 camisetas + 1 carteira → +1 = 8 + 2), num único /cart/update.js — o
  cliente não desfaz o combo sem querer nem perde o brinde por tirar uma peça. Depois,
  redesenha a gaveta com a seção que já vem na resposta (mesmo caminho do cart.js, #325) e o
  ícone do carrinho.

  Fail-safe: qualquer erro mostra a mensagem na linha e relê a gaveta; nunca trava a compra.
*/
(function () {
  'use strict';

  var fila = function (fn) {
    return typeof window.queueCartMutation === 'function' ? window.queueCartMutation(fn) : fn();
  };

  function textoErro(body) {
    var msg = body && (body.description || body.message);
    return typeof msg === 'string' && msg ? msg : 'Não deu para atualizar o combo. Tente de novo.';
  }

  // POST no carrinho. `secoes` = pedir a gaveta redesenhada na resposta (o último passo pede).
  function post(url, corpo, secoes) {
    if (secoes !== false) {
      corpo.sections = ['cart-drawer', 'cart-icon-bubble'];
      corpo.sections_url = window.location.pathname;
    }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo),
    }).then(function (r) {
      return r.json().then(function (body) { return { ok: r.ok, body: body }; });
    });
  }

  function redesenhar(res) {
    var sections = (res && res.sections) || {};
    var itens = document.querySelector('cart-drawer-items');
    if (itens && typeof itens.onCartUpdate === 'function') itens.onCartUpdate(sections['cart-drawer']);
    var bolha = document.getElementById('cart-icon-bubble');
    if (bolha && sections['cart-icon-bubble']) {
      var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var novo = doc.querySelector('.shopify-section');
      if (novo) bolha.innerHTML = novo.innerHTML;
    }
    var gaveta = document.querySelector('cart-drawer');
    if (gaveta && res && typeof res.item_count === 'number') gaveta.classList.toggle('is-empty', res.item_count === 0);
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-combo-grupo', cartData: res });
    }
  }

  document.addEventListener('click', function (e) {
    var botao = e.target.closest('[data-cb-acao]');
    if (!botao) return;
    var linha = botao.closest('[data-cb-grupo]');
    if (!linha || linha.classList.contains('cart-combo--ocupado')) return;
    e.preventDefault();

    var acao = botao.getAttribute('data-cb-acao');
    var tarefa = null;
    var kitPecas = linha.getAttribute('data-kit-pecas');
    if (kitPecas) {
      // Linha de KIT (snippets/cart-kit-linha). A linha juntada tem sempre qtd 1, com N kits
      // dentro: mudar a qtd dela multiplicaria tudo. + adiciona as peças de UM kit (mesmas
      // properties: a Cart Transform junta de novo); − tira o kit e repõe N−1; lixeira tira tudo.
      var pecas, chaves;
      try {
        pecas = JSON.parse(kitPecas);
        chaves = JSON.parse(linha.getAttribute('data-kit-linhas') || '[]');
      } catch (err) {
        return;
      }
      var n = parseInt(linha.getAttribute('data-kit-n'), 10) || 1;
      if (!pecas.length || !chaves.length) return;
      if (acao === 'menos' && n <= 1) return;
      var itens = function (kits) {
        return pecas.map(function (pc) {
          var props = {};
          Object.keys(pc.props || {}).forEach(function (k) {
            props[k] = String(pc.props[k]).replace(/&amp;/g, '&');
          });
          return { id: pc.id, quantity: (Number(pc.q) || 0) * kits, properties: props };
        });
      };
      var zera = {};
      chaves.forEach(function (k) { zera[k] = 0; });
      tarefa = function () {
        if (acao === 'mais') return post('/cart/add.js', { items: itens(1) });
        return post('/cart/update.js', { updates: zera }, acao === 'remover').then(function (res) {
          if (acao === 'remover' || !res.ok) return res;
          return post('/cart/add.js', { items: itens(n - 1) });
        });
      };
    } else {
      var updates = {};
      var comps = parseInt(linha.getAttribute('data-cb-comps'), 10) || 1;
      var novo = acao === 'mais' ? comps + 1 : acao === 'menos' ? comps - 1 : 0;
      if (novo < 0 || (acao === 'menos' && novo < 1)) return;

      var linhas;
      try {
        linhas = JSON.parse(linha.getAttribute('data-cb-linhas') || '[]');
      } catch (err) {
        linhas = [];
      }
      if (!linhas.length) return;
      linhas.forEach(function (l) {
        updates[l.key] = (Number(l.por) || 0) * novo;
      });
      tarefa = function () { return post('/cart/update.js', { updates: updates }); };
    }

    var erroEl = linha.querySelector('[data-cb-erro]');
    if (erroEl) erroEl.hidden = true;
    linha.classList.add('cart-combo--ocupado');

    fila(tarefa)
      .then(function (res) {
        if (!res.ok) {
          linha.classList.remove('cart-combo--ocupado');
          if (erroEl) {
            erroEl.textContent = textoErro(res.body);
            erroEl.hidden = false;
          }
          return;
        }
        redesenhar(res.body);
      })
      .catch(function () {
        linha.classList.remove('cart-combo--ocupado');
        if (erroEl) {
          erroEl.textContent = 'Não deu para atualizar o combo. Confira a conexão e tente de novo.';
          erroEl.hidden = false;
        }
      });
  });
})();
